import * as React from "react"
import { makeStyles } from "makeStyles"
import useMediaQuery from "@mui/material/useMediaQuery"
// import Button from "../Buttons/Button"

const useStyles = makeStyles()(() => ({
	IncreaseDecrease: {
		cursor: "pointer",
		userSelect: "none",
		background: "#E0EAEC",
		width: "33.3%",
		height: "35px",
		color: "black",
		border: "none",
		outline: "none",
		"&:hover": {
			background: "#E0EAEC",
		},
	},
	input: {
		width: "33.3%",
		height: "31px",
		textAlign: "center",
		outline: "none",
		boxShadow: "none",
		borderRadius: 0,
		border: "none",
		borderTop: "1px solid #E0EAEC",
		borderBottom: "1px solid #E0EAEC",
	},
	btnGroup: {
		display: "flex",
		width: "100px",
		borderRadius: "4px",
	},
}))

const ChangeAmountButton = ({
	quantity,
	onChange,
	minQuantity = 0,
	maxQuantity = Infinity,
	disabled = false,
}: Props) => {
	const isSmallerThan580pxs = useMediaQuery("(max-width: 580px)")

	const { classes } = useStyles()
	const validateChange = (delta: number) => {
		const newQuantity = quantity + delta
		if (newQuantity >= minQuantity && newQuantity <= maxQuantity) onChange(newQuantity)
	}

	const onChangeAmount = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newQuantity = Number(event.target.value)
		const delta = newQuantity - quantity
		validateChange(delta)
	}

	return (
		<div
			className={classes.btnGroup}
			style={{
				width: isSmallerThan580pxs ? "130px" : "initial",
			}}
		>
			<button
				disabled={disabled}
				onClick={() => validateChange(-1)}
				className={classes.IncreaseDecrease}
			>
				<div style={{ padding: 0 }}>-</div>
			</button>
			<input
				type="number"
				aria-label="Product Quantity"
				value={quantity}
				onChange={onChangeAmount}
				data-hj-whitelist
				disabled={disabled}
				className={classes.input}
				style={{
					height: isSmallerThan580pxs ? "28px" : "initial",
				}}
			/>
			<button
				disabled={disabled}
				onClick={() => validateChange(+1)}
				className={classes.IncreaseDecrease}
			>
				<div style={{ padding: 0 }}>+</div>
			</button>
		</div>
	)
}

interface Props {
	quantity: number
	onChange: (newAmount: number) => void
	disabled?: boolean
	minQuantity?: number
	maxQuantity?: number
	showButtons?: boolean
}

export default ChangeAmountButton
